'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var RightArrow = {};

exports.__exports = RightArrow;
